import { Flex, Grid, Layout, Menu, Typography, theme } from 'antd'
import { useTranslation } from 'react-i18next'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { BrandLogo } from '@/shared/ui/BrandLogo'
import { LanguageSwitcher } from '@/shared/ui/LanguageSwitcher'
import { ThemeToggle } from '@/shared/ui/ThemeToggle'
import { CONTENT_MAX_WIDTH, HEADER_HEIGHT } from './layoutMetrics'
import { findActiveNavKey } from './navItems'
import { ProfileMenu } from './ProfileMenu'
import { useVisibleNav } from './useVisibleNav'

/**
 * Header — desktopda to'liq navigatsiya bilan, telefonda faqat brend va
 * amallar (u yerda navigatsiya pastki tab-barda, `MobileTabBar`).
 *
 * ⚠️ MENYU TAKRORLANMAYDI: tor ekranda gorizontal menyu CHIZILMAYDI,
 * aks holda bir xil to'rt havola ekranning ikki chetida turardi va
 * ulardan biri (yuqoridagisi) barmoq yetmaydigan joyda bo'lardi.
 *
 * ⚠️ KOMPYUTERDA JURNALLAR HAM SHU YERDA (`nav.secondary`). Telefonda
 * ular hisob menyusiga tushadi — `navItems.tsx` dagi sabab: pastki
 * tab-barni oltita bandga cho'zish tugmalarni 44px dan toraytirardi.
 *
 * ⚠️ ICHKI USTUN KONTENT BILAN BIR O'QDA (`CONTENT_MAX_WIDTH`). Ilgari
 * header butun enni olardi va 1920px da menyuning oxirgi bandi kontent
 * ustunidan ancha o'ngda tugardi — ikki vertikal o'q. Telefonda bu
 * chegara hech narsani cheklamaydi.
 */
export function AppHeader({ isMobile }: { isMobile: boolean }) {
  const { t } = useTranslation()
  const { token } = theme.useToken()
  const location = useLocation()
  const navigate = useNavigate()
  const nav = useVisibleNav()
  const screens = Grid.useBreakpoint()
  const showTagline = screens.xl === true

  const activeKey = findActiveNavKey(location.pathname)
  const menuItems = isMobile ? [] : [...nav.primary, ...nav.secondary]

  return (
    <Layout.Header
      className="xsib-header"
      style={{
        background: token.colorBgContainer,
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        padding: isMobile ? '0 12px' : '0 24px',
        height: HEADER_HEIGHT,
        lineHeight: `${HEADER_HEIGHT}px`,
      }}
    >
      <Flex
        align="center"
        gap={16}
        style={{ maxWidth: CONTENT_MAX_WIDTH, margin: '0 auto', height: '100%' }}
      >
        <Flex align="center" gap={12} style={{ minWidth: 0 }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', minHeight: 44 }}>
            <BrandLogo height={isMobile ? 24 : 28} label={t('app.name')} />
          </Link>
          {showTagline ? (
            <Typography.Text
              type="secondary"
              style={{
                whiteSpace: 'nowrap',
                lineHeight: '20px',
                paddingInlineStart: 12,
                borderInlineStart: `1px solid ${token.colorBorderSecondary}`,
              }}
            >
              {t('app.tagline')}
            </Typography.Text>
          ) : null}
        </Flex>

        {isMobile ? null : (
          <Menu
            mode="horizontal"
            selectedKeys={[activeKey]}
            items={menuItems.map((item) => ({
              key: item.key,
              icon: item.icon,
              label: t(item.labelKey),
            }))}
            onClick={({ key }) => {
              const item = menuItems.find((n) => n.key === key)
              if (item) navigate(item.path)
            }}
            style={{ flex: 1, minWidth: 0, borderBottom: 'none' }}
          />
        )}

        <Flex align="center" gap={4} style={{ marginInlineStart: isMobile ? 'auto' : 0, flexShrink: 0 }}>
          <LanguageSwitcher />
          <ThemeToggle />
          <ProfileMenu isMobile={isMobile} />
        </Flex>
      </Flex>
    </Layout.Header>
  )
}
